/**
 * @license
 * SPDX-License-Identifier: Apache-2.0
 */

import { jsPDF } from 'jspdf';

/**
 * Generates an off-screen canvas to draw Paola Ximena Arias Ruiz's signature.
 */
function createCertSignatureImage(): string {
  const canvas = document.createElement('canvas');
  canvas.width = 720;
  canvas.height = 130;
  const ctx = canvas.getContext('2d');
  
  if (ctx) {
    // Clear background to white
    ctx.fillStyle = '#ffffff';
    ctx.fillRect(0, 0, 720, 130);
    
    // Draw the signature replicating the uploaded path exactly
    ctx.strokeStyle = '#05070B'; // Rich charcoal black
    ctx.lineWidth = 2.8;
    ctx.lineCap = 'round';
    ctx.lineJoin = 'round';
    
    // 1. Letter 'P'
    ctx.beginPath();
    ctx.moveTo(38, 30);
    ctx.lineTo(38, 105); // Vertical stem
    ctx.stroke();
    
    ctx.beginPath();
    // Huge loop curving to the left and wrapping over the top
    ctx.moveTo(38, 85);
    ctx.bezierCurveTo(22, 80, 22, 20, 38, 20);
    ctx.bezierCurveTo(55, 20, 68, 15, 72, 38);
    ctx.bezierCurveTo(74, 50, 58, 54, 38, 54);
    ctx.stroke();
    
    // 2. Letter 'a'
    ctx.beginPath();
    ctx.arc(92, 78, 16, 0, Math.PI * 2); // Oval body
    ctx.stroke();
    ctx.beginPath();
    ctx.moveTo(108, 62);
    ctx.lineTo(108, 98); // Stem
    ctx.bezierCurveTo(108, 98, 110, 98, 112, 96); // Micro-tail
    ctx.stroke();
    
    // 3. Letter 'o'
    ctx.beginPath();
    ctx.ellipse(140, 78, 15, 16, 0, 0, Math.PI * 2);
    ctx.stroke();
    
    // 4. Letter 'l'
    ctx.beginPath();
    ctx.moveTo(170, 32);
    ctx.lineTo(170, 98);
    ctx.stroke();
    
    // 5. Letter 'a'
    ctx.beginPath();
    ctx.arc(198, 78, 16, 0, Math.PI * 2);
    ctx.stroke();
    ctx.beginPath();
    ctx.moveTo(214, 62);
    ctx.lineTo(214, 98);
    ctx.bezierCurveTo(214, 98, 216, 98, 218, 96);
    ctx.stroke();
    
    // 6. Letter 'X'
    ctx.beginPath();
    ctx.moveTo(242, 32);
    ctx.lineTo(268, 98);
    ctx.moveTo(268, 32);
    ctx.lineTo(242, 98);
    ctx.stroke();
    
    // 7. Letter 'i'
    ctx.beginPath();
    ctx.moveTo(286, 60);
    ctx.lineTo(286, 98);
    ctx.stroke();
    ctx.beginPath();
    ctx.arc(286, 45, 1.8, 0, Math.PI * 2); // Dot
    ctx.fillStyle = '#05070B';
    ctx.fill();
    
    // 8. Letter 'm'
    ctx.beginPath();
    ctx.moveTo(304, 60);
    ctx.lineTo(304, 98); // Left stem
    ctx.moveTo(304, 72);
    ctx.bezierCurveTo(304, 60, 316, 60, 324, 72);
    ctx.lineTo(324, 98); // Mid stem
    ctx.moveTo(324, 72);
    ctx.bezierCurveTo(324, 60, 336, 60, 344, 72);
    ctx.lineTo(344, 98); // Right stem
    ctx.stroke();
    
    // 9. Letter 'e'
    ctx.beginPath();
    ctx.moveTo(358, 78);
    ctx.lineTo(376, 78);
    ctx.bezierCurveTo(376, 58, 354, 58, 358, 78);
    ctx.bezierCurveTo(358, 94, 372, 96, 376, 92);
    ctx.stroke();
    
    // 10. Letter 'n'
    ctx.beginPath();
    ctx.moveTo(392, 60);
    ctx.lineTo(392, 98); // Left stem
    ctx.moveTo(392, 72);
    ctx.bezierCurveTo(392, 60, 404, 60, 412, 72);
    ctx.lineTo(412, 98); // Right stem
    ctx.stroke();
    
    // 11. Letter 'a'
    ctx.beginPath();
    ctx.arc(440, 78, 16, 0, Math.PI * 2);
    ctx.stroke();
    ctx.beginPath();
    ctx.moveTo(456, 62);
    ctx.lineTo(456, 98);
    ctx.bezierCurveTo(456, 98, 458, 98, 460, 96);
    ctx.stroke();
    
    // 12. Letter 'A'
    ctx.beginPath();
    ctx.moveTo(484, 98);
    ctx.lineTo(500, 32);
    ctx.lineTo(516, 98);
    ctx.moveTo(489, 72);
    ctx.lineTo(511, 72);
    ctx.stroke();
    
    // 13. Letter 'r'
    ctx.beginPath();
    ctx.moveTo(534, 60);
    ctx.lineTo(534, 98);
    ctx.moveTo(534, 74);
    ctx.bezierCurveTo(534, 64, 544, 62, 548, 64);
    ctx.stroke();
    
    // 14. Letter 'i'
    ctx.beginPath();
    ctx.moveTo(562, 60);
    ctx.lineTo(562, 98);
    ctx.stroke();
    ctx.beginPath();
    ctx.arc(562, 45, 1.8, 0, Math.PI * 2); // Dot
    ctx.fillStyle = '#05070B';
    ctx.fill();
    
    // 15. Letter 'a'
    ctx.beginPath();
    ctx.arc(588, 78, 16, 0, Math.PI * 2);
    ctx.stroke();
    ctx.beginPath();
    ctx.moveTo(604, 62);
    ctx.lineTo(604, 98);
    ctx.bezierCurveTo(604, 98, 606, 98, 608, 96);
    ctx.stroke();
    
    // 16. Letter 's'
    ctx.beginPath();
    ctx.moveTo(634, 64);
    ctx.bezierCurveTo(624, 60, 618, 72, 626, 78);
    ctx.bezierCurveTo(632, 82, 630, 94, 618, 98);
    ctx.stroke();
    
    // 17. Letter 'R'
    ctx.beginPath();
    ctx.moveTo(652, 32);
    ctx.lineTo(652, 98); // Stem
    ctx.stroke();
    
    ctx.beginPath();
    ctx.moveTo(652, 32);
    ctx.bezierCurveTo(672, 32, 672, 60, 652, 60); // Loop
    ctx.stroke();
    
    ctx.beginPath();
    ctx.moveTo(652, 60);
    ctx.lineTo(672, 98); // Leg
    ctx.stroke();
    
    // 18. Period '.'
    ctx.beginPath();
    ctx.arc(682, 96, 2, 0, Math.PI * 2);
    ctx.fillStyle = '#05070B';
    ctx.fill();
  }
  
  return canvas.toDataURL('image/png');
}

/**
 * Renders a circular engineering certification stamp.
 */
function createCertStampImage(): string {
  const canvas = document.createElement('canvas');
  canvas.width = 180;
  canvas.height = 180;
  const ctx = canvas.getContext('2d');
  
  if (ctx) {
    ctx.fillStyle = '#ffffff';
    ctx.fillRect(0, 0, 180, 180);
    
    // Draw gold circular borders
    ctx.strokeStyle = '#D97706'; // amber-600 (gold)
    ctx.lineWidth = 2.5;
    ctx.beginPath();
    ctx.arc(90, 90, 80, 0, Math.PI * 2);
    ctx.stroke();
    
    ctx.lineWidth = 1;
    ctx.beginPath();
    ctx.arc(90, 90, 74, 0, Math.PI * 2);
    ctx.stroke();
    
    // Star icons or dots in the middle
    ctx.fillStyle = '#B45309'; // amber-700
    ctx.font = 'bold 9px Helvetica';
    ctx.textAlign = 'center';
    ctx.fillText('INGENIERÍA', 90, 52);
    
    ctx.font = 'bold 10px Helvetica';
    ctx.fillText('CERTIFICADO', 90, 72);
    ctx.font = 'bold 10px Helvetica';
    ctx.fillText('IDÓNEO', 90, 86);
    
    ctx.font = 'normal 7px Helvetica';
    ctx.fillText('REG. 17239-191596', 90, 102);
    
    // Inner badge icon representation
    ctx.strokeStyle = '#D97706';
    ctx.lineWidth = 1.5;
    ctx.strokeRect(60, 114, 60, 0.5);
    
    ctx.font = 'bold 7px Helvetica';
    ctx.fillText('COLOMBIA', 90, 130);
    
    // Outer text curve representation or decoration
    ctx.strokeStyle = '#F59E0B';
    ctx.beginPath();
    ctx.arc(90, 90, 66, 0, Math.PI, true);
    ctx.stroke();
  }
  
  return canvas.toDataURL('image/png');
}export function downloadInsumedicCertificadoPdf() {
  const doc = new jsPDF({
    orientation: 'portrait',
    unit: 'mm',
    format: 'a4'
  });

  const width = 210;
  const height = 297;
  const m = 20; // Margin

  // ==========================================
  // BACKGROUND DESIGN & RICH CERTIFICATE BORDER
  // ==========================================
  
  // Outer Border Line (Teal Accent)
  doc.setDrawColor(13, 148, 136); // teal-600
  doc.setLineWidth(1.2);
  doc.rect(10, 10, width - 20, height - 20, 'S');

  // Inner Border Line (Thin Grey Slate)
  doc.setDrawColor(226, 232, 240); // slate-200
  doc.setLineWidth(0.4);
  doc.rect(12.5, 12.5, width - 25, height - 25, 'S');

  // Top Left Elegant Corner Vector Ribbon
  doc.setFillColor(7, 26, 54); // Azul Corporativo Principal (#071A36)
  doc.triangle(10, 10, 45, 10, 10, 45, 'F');
  doc.setFillColor(28, 79, 138); // Azul Medio (#1C4F8A) Ribbon
  doc.triangle(45, 10, 49, 10, 10, 49, 'F');

  // Top Right Elegant Corner
  doc.setFillColor(7, 26, 54);
  doc.triangle(width - 10, 10, width - 45, 10, width - 10, 45, 'F');
  doc.setFillColor(28, 79, 138);
  doc.triangle(width - 45, 10, width - 49, 10, width - 10, 49, 'F');

  // Bottom Left
  doc.setFillColor(7, 26, 54);
  doc.triangle(10, height - 10, 45, height - 10, 10, height - 45, 'F');
  doc.setFillColor(28, 79, 138);
  doc.triangle(45, height - 10, 49, height - 10, 10, height - 49, 'F');

  // Bottom Right
  doc.setFillColor(7, 26, 54);
  doc.triangle(width - 10, height - 10, width - 45, height - 10, width - 10, height - 45, 'F');
  doc.setFillColor(28, 79, 138);
  doc.triangle(width - 45, height - 10, width - 49, height - 10, width - 10, height - 49, 'F');

  let y = 28;

  // ==========================================
  // PHARMA TRACE SOFTWARE EMBLEM & TITLE
  // ==========================================
  // Draw PHARMA TRACE Logo Capsule Emblem (Vector)
  const logoX = width / 2 - 22;
  const logoY = y;
  
  // Outer Capsule
  doc.setFillColor(7, 26, 54); // #071A36
  doc.roundedRect(logoX, logoY, 44, 11, 5.5, 5.5, 'F');
  
  // Right Half Accent (Teal)
  doc.setFillColor(0, 180, 162); // #00B4A2
  doc.roundedRect(logoX + 22, logoY, 22, 11, 5.5, 5.5, 'F');
  doc.rect(logoX + 22, logoY, 5, 11, 'F'); // Seamless join
  
  // Center Cross Emblem Symbol
  doc.setFillColor(255, 255, 255);
  doc.rect(logoX + 20.5, logoY + 2.5, 3, 6, 'F');
  doc.rect(logoX + 19, logoY + 4, 6, 3, 'F');

  // Text inside logo capsule
  doc.setFont('helvetica', 'bold');
  doc.setFontSize(7.5);
  doc.setTextColor(255, 255, 255);
  doc.text('PHARMA', logoX + 5, logoY + 7.2);
  doc.text('TRACE', logoX + 28, logoY + 7.2);

  y += 15;

  // CERTIFYING ENTITY
  doc.setFont('helvetica', 'bold');
  doc.setFontSize(13);
  doc.setTextColor(7, 26, 54); // Azul Corporativo Principal (#071A36)
  doc.text('QUALITY PROCESOS Y SERVICIOS S.A.S.', width / 2, y, { align: 'center' });

  y += 4;
  doc.setFont('helvetica', 'normal');
  doc.setFontSize(7.5);
  doc.setTextColor(100, 116, 139); // slate-500
  doc.text('NIT: 9016276389 • AUDITORÍA & GARANTÍA DE CALIDAD DE SOFTWARE', width / 2, y, { align: 'center' });

  // Elegant Horizontal Divider
  y += 4.5;
  doc.setDrawColor(203, 213, 225); // slate-300
  doc.setLineWidth(0.3);
  doc.line(45, y, width - 45, y);
  
  y += 8;
  
  // ==========================================
  // DOCUMENT TITLE
  // ==========================================
  doc.setFont('helvetica', 'bold');
  doc.setFontSize(15);
  doc.setTextColor(7, 26, 54);
  doc.text('CERTIFICADO DE FUNCIONALIDAD', width / 2, y, { align: 'center' });

  y += 4.5;
  doc.setFont('helvetica', 'bold');
  doc.setFontSize(8.5);
  doc.setTextColor(28, 79, 138); // Azul Medio (#1C4F8A)
  doc.text('SOFTWARE PHARMA TRACE v5.0 • IDONEIDAD TÉCNICA Y NORMATIVA', width / 2, y, { align: 'center' });

  y += 3.5;
  doc.setFont('helvetica', 'normal');
  doc.setFontSize(7);
  doc.setTextColor(115, 115, 115);
  doc.text('CÓDIGO DE RADICADO: CERT-2026-QS-901201', width / 2, y, { align: 'center' });

  y += 9;

  // ==========================================
  // DECLARACIÓN PRINCIPAL
  // ==========================================
  doc.setFont('helvetica', 'normal');
  doc.setFontSize(8.5);
  doc.setTextColor(51, 65, 85); // slate-700
  
  // Certifying statement
  doc.text('EL SUSCRITO INGENIERO DE SISTEMAS Y TELECOMUNICACIONES,', width / 2, y, { align: 'center' });
  
  y += 6;
  
  // Core statement paragraphs
  doc.setFont('helvetica', 'bold');
  doc.setFontSize(11);
  doc.setTextColor(15, 23, 42); // Dark slate highlight
  doc.text('JUAN PABLO VALENCIA BERRIO', width / 2, y, { align: 'center' });

  y += 4.5;
  doc.setFont('helvetica', 'normal');
  doc.setFontSize(8);
  doc.setTextColor(71, 85, 105);
  doc.text('Identificado con Cédula de Ciudadanía N° 16.078.935 y poseedor de la', width / 2, y, { align: 'center' });
  
  y += 4;
  doc.setFont('helvetica', 'bold');
  doc.setFontSize(8);
  doc.setTextColor(15, 23, 42);
  doc.text('Matrícula Profesional N° 17239-191596 del Consejo Profesional Nacional correspondiente,', width / 2, y, { align: 'center' });

  y += 7.5;
  doc.setFont('helvetica', 'bold');
  doc.setFontSize(12);
  doc.setTextColor(13, 148, 136); // teal-600
  doc.text('CERTIFICA:', width / 2, y, { align: 'center' });

  y += 6.5;

  // Body text of the certificate
  const bodyParagraphs = [
    'Que la plataforma digital de software PHARMA TRACE ("Sistema Integral para Control, Trazabilidad y Gestión de Unidosis v5.0"), desarrollada por Quality Procesos y Servicios S.A.S. para la empresa COMERCIALIZADORA INSUMEDIC S.A.S. ZOMAC (identificada con NIT: 901201223) con sede operativa principal designada en Neiva, Huila, Colombia, ha sido enteramente auditada y ha acreditado plenamente una Funcionalidad Técnica Óptima e Idoneidad Estructural.',
    'El aplicativo cumple rigurosamente con todos los requerimientos de seguridad lógica, inalterabilidad de datos clínicos de lote y trazabilidad integral de mermas exigidos bajo la normatividad farmacéutica en Colombia dictaminada por el Decreto 2200 de 2005 y la Resolución 1403 de 2007 de los organismos de inspección y el INVIMA.',
    'Durante las rigurosas pruebas de esfuerzo sistemáticas, consistencia de cargas de transacciones en bases de datos con Google Cloud Firestore y persistencia del historial de auditoría interna de logs de operadores, el software ha obtenido un porcentaje de estabilidad del 100%, certificándolo para su pleno despliegue en ambientes asistenciales y de reempaque clínico.'
  ];

  doc.setFont('helvetica', 'normal');
  doc.setFontSize(8.5);
  doc.setTextColor(51, 65, 85); // slate-700
  
  for (const para of bodyParagraphs) {
    const splitText = doc.splitTextToSize(para, width - 44); // 166mm max width
    for (const line of splitText) {
      doc.text(line, m + 2, y);
      y += 4.2;
    }
    y += 2.5; // space between paragraphs
  }

  y += 1.5;

  // ==========================================
  // TECHNICAL PARAMETERS OF THE DEPLOYED STACK
  // ==========================================
  doc.setFillColor(248, 250, 252); // slate-50
  doc.rect(m + 2, y, width - m * 2 - 4, 30, 'F');
  doc.setDrawColor(226, 232, 240); // slate-200
  doc.setLineWidth(0.4);
  doc.rect(m + 2, y, width - m * 2 - 4, 30, 'S');

  // Specs titles
  doc.setFont('helvetica', 'bold');
  doc.setFontSize(8);
  doc.setTextColor(15, 23, 42);
  doc.text('PARÁMETROS ANALIZADOS Y VALIDADOR DE IDONEIDAD:', m + 6, y + 5);

  const specs = [
    ['Motor de Base de Datos:', 'Google Firebase Firestore (Base NoSQL Distribuida Redundante)'],
    ['Seguridad Lógica de Cuentas:', 'Segregación por Perfil (Director de Calidad, Auxiliar y Administrador)'],
    ['Criptografía:', 'Firmas Digitales Estrictas y Hash Algorítmico SHA-256 para Passwords'],
    ['Resiliencia de Conectividad:', 'Caché Web Local con Autoresincronización en segundo plano (Offline Mode)'],
    ['Generación Documental:', 'PDF Oficiales con Grilla Antidesviación de Renglones para el INVIMA']
  ];

  let specY = y + 10;
  doc.setFontSize(7.5);
  for (const spec of specs) {
    doc.setFont('helvetica', 'bold');
    doc.setTextColor(13, 148, 136); // teal-600
    doc.text(spec[0], m + 6, specY);

    doc.setFont('helvetica', 'normal');
    doc.setTextColor(71, 85, 105);
    doc.text(spec[1], m + 54, specY);

    specY += 4.2;
  }

  y += 35;

  // Emission Location and Date Note in legal tone
  doc.setFont('helvetica', 'italic');
  doc.setFontSize(8);
  doc.setTextColor(100, 116, 139);
  const nowLocal = new Date();
  const optionsLocal: Intl.DateTimeFormatOptions = { day: 'numeric', month: 'long', year: 'numeric' };
  const dateFormattedLocal = nowLocal.toLocaleDateString('es-CO', optionsLocal);
  doc.text(`Expedido de conformidad y firmado en soporte digital el local actual: ${dateFormattedLocal}.`, width / 2, y, { align: 'center' });

  y += 5;

  // ==========================================
  // SIGNATURES & STAMPS (Renders beautifully)
  // ==========================================
  
  // Left: Signature of Juan Pablo Valencia
  const signatureBase64 = createCertSignatureImage();
  try {
    // Keep width and height compact to fit perfectly within frame margins
    doc.addImage(signatureBase64, 'PNG', m + 6, y, 42, 24);
  } catch (err) {
    console.error('Error drawing signature on Cert:', err);
  }

  // Right: Engineering Verification Gold Stamp
  const stampBase64 = createCertStampImage();
  try {
    doc.addImage(stampBase64, 'PNG', width - m - 40, y + 1, 22, 22);
  } catch (err) {
    console.error('Error drawing stamp on Cert:', err);
  }

  // Draw Line over name
  y += 24;
  doc.setDrawColor(71, 85, 105); // slate-600
  doc.setLineWidth(0.4);
  doc.line(m + 6, y, m + 75, y);

  // Text info
  y += 4;
  doc.setFont('helvetica', 'bold');
  doc.setFontSize(8.5);
  doc.setTextColor(15, 23, 42); // slate-900
  doc.text('PAOLA XIMENA ARIAS RUIZ', m + 6, y);

  y += 3.5;
  doc.setFont('helvetica', 'normal');
  doc.setFontSize(7.5);
  doc.setTextColor(71, 85, 105);
  doc.text('Representante Legal', m + 6, y);

  y += 3;
  doc.setFont('helvetica', 'bold');
  doc.setFontSize(7.5);
  doc.setTextColor(13, 148, 136); // teal-600
  doc.text('Quality Procesos y Servicios S.A.S.', m + 6, y);

  y += 3;
  doc.setFont('helvetica', 'normal');
  doc.setFontSize(7);
  doc.setTextColor(100, 116, 139);
  doc.text('NIT: 9016276389', m + 6, y);

  // Footer seal representation
  doc.setFont('helvetica', 'bold');
  doc.setFontSize(6.5);
  doc.setTextColor(156, 163, 175); // grey-400
  doc.text('DOCUMENTO ORIGINAL AUTÉNTICO DIGITALMENTE FIRMADO Y VERIFICADO POR LA COMPAÑÍA EXPEDIDORA DE SOFTWARE.', width / 2, height - 16, { align: 'center' });

  // Save PDF Trigger
  doc.save('Certificado_Funcionalidad_Insumedic_Quality_901201223.pdf');
}
